import {Component, OnInit, ViewChild} from '@angular/core';
import {AjaxService} from 'AjaxService';
import {UntypedFormGroup, Validators, FormGroup, FormControl} from '@angular/forms';
import {RecaptchaComponent} from 'ng-recaptcha-2';
import notify from 'devextreme/ui/notify';
import {Router} from '@angular/router';
import {SpinnerService} from '@services/spinner.service';

@Component({
    selector: 'cz-pass-recovery',
    templateUrl: './pass-recovery.component.html',
    styleUrls: ['./pass-recovery.component.css'],
    standalone: false
})
export class PassRecoveryComponent implements OnInit {
  @ViewChild('recaptcha', {static: false}) rechaptaComp: RecaptchaComponent;
  public form: any;
  isCaptchResolved: boolean = false;
  errMsg: string = '';
  loading: boolean = false;

  constructor(private spinnerService: SpinnerService, private ajaxService: AjaxService, private router: Router) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      username: new FormControl({value: '', disabled: false}, Validators.required),
      email: new FormControl({value: '', disabled: false}, Validators.required),
    });
  }

  onSubmit() {
    Object.entries(this.form.controls).forEach(([key, control]) => {
      Object.entries(this.form.controls).forEach(([key, control]) => {
        (control as FormControl).markAsTouched();
      });
    });

    // if (!this.isCaptchResolved) { // ToDo RR1 = enable
    //   this.errMsg = 'Sind Sie ein Mensch?';
    //   return;
    // }

    if (!this.form.invalid) {
      this.startLoading();
      this.ajaxService.post('api/Account/PasswordRecovery', this.form.value).subscribe({
        next: () => {
          this.stopLoading();
          notify(
            {
              message: 'Es wird ein neues Passwort an Ihre Email-Adresse gesendet.',
              width: 600,
            },
            'success',
            3000
          );
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (err) => {
          this.stopLoading();
          this.isCaptchResolved = false;
          if (this.rechaptaComp) {
            this.rechaptaComp.reset();
          }

          setTimeout(() => {
            throw err;
          }, 0);
        },
      });
    }
  }

  onClickAbbruch() {
    this.router.navigate(['/login']);
  }

  onKeyupEnter() {
    this.onSubmit();
  }

  resolved(captchaResponse: string) {
    this.isCaptchResolved = true;
  }

  private startLoading() {
    this.spinnerService.show();
    this.loading = true;
  }

  private stopLoading() {
    this.spinnerService.hide();
    this.loading = false;
  }
}
